import {
  defineBlock,
  smartProps,
  useInspectorControl,
  BlockWrapper,
} from "@smartfire/js-block-engine";
import { EditableHeading } from "@smartfire/components";
import { ReactComponent as Background1 } from "./assets/background-1.svg";
import { ReactComponent as Background2 } from "./assets/background-2.svg";
import { ReactComponent as Background2Mobile } from "./assets/background-2-mobile.svg";
import { useMediaQuery } from "@mui/material";
import { lazy } from "react";
import { useTranslation } from "react-i18next";
import Media from "./Media";
import style from "./style.module.scss";
import { ReactComponent as FacebookLogo } from "../assets/Facebook.svg";
import { ReactComponent as InstagramLogo } from "../assets/instagram.svg";
import { ReactComponent as PinterestLogo } from "../assets/pinterest.svg";
import { ReactComponent as YouTubeLogo } from "../assets/youtube.svg";
import { ReactComponent as LinkedinLogo } from "../assets/linkedin.svg";
import { ReactComponent as TwitterLogo } from "../assets/Twitter.svg";

const Inspector = lazy(() => import("./inspector.js"));

function Block({
  links,
  media1Link,
  media2Link,
  media3Link,
  media4Link,
  media5Link,
}) {
  useInspectorControl(Inspector);
  const isTablet = useMediaQuery("(max-width: " + style.tabletBreakpoint + ")");
  // React i18next
  const { t } = useTranslation();

  const findSocial = (link) => {
    if (link?.includes("facebook")) {
      return <FacebookLogo />;
    }
    if (link?.includes("instagram")) {
      return <InstagramLogo />;
    }
    if (link?.includes("pinterest")) {
      return <PinterestLogo />;
    }
    if (link?.includes("youtube")) {
      return <YouTubeLogo />;
    }
    if (link?.includes("linkedin")) {
      return <LinkedinLogo />;
    }
    if (link?.includes("twitter") || link?.includes("x.com")) {
      return <TwitterLogo />;
    }
    return;
  };

  return (
    <BlockWrapper.Div className={style.block}>
      <div className={style.wrapper}>
        <div className={style.header}>
          <EditableHeading
            className={style.title}
            smartProp={"title"}
            placeholder={`${t("Title")}...`}
          />

          <div className={style.links}>
            {links &&
              links.map((link, index) => {
                const icon = findSocial(link.url);
                return (
                  <a href={link.url} key={index}>
                    {link.url && <span>{icon}</span>}
                    {link.label}
                  </a>
                );
              })}
          </div>
        </div>

        <div className={style.mediaWrapper}>
          <Media
            imageProp={"image1"}
            link={media1Link}
            icon={findSocial(media1Link)}
          />
          <Media
            imageProp={"image2"}
            link={media2Link}
            icon={findSocial(media2Link)}
          />
          <Media
            imageProp={"image3"}
            link={media3Link}
            icon={findSocial(media3Link)}
          />
          <Media
            imageProp={"image4"}
            link={media4Link}
            icon={findSocial(media4Link)}
          />
          <Media
            imageProp={"image5"}
            link={media5Link}
            icon={findSocial(media5Link)}
          />
        </div>
      </div>

      <Background1 className={style.background1} />
      {!isTablet ? (
        <Background2 className={style.background2} />
      ) : (
        <Background2Mobile className={style.background2} />
      )}
    </BlockWrapper.Div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.object.withDefault({
      headingLevel: 2,
      content: "",
    }),
    links: smartProps.array.withDefault([]),
    image1: smartProps.image,
    image2: smartProps.image,
    image3: smartProps.image,
    image4: smartProps.image,
    image5: smartProps.image,
    media1Link: smartProps.string.withDefault(""),
    media2Link: smartProps.string.withDefault(""),
    media3Link: smartProps.string.withDefault(""),
    media4Link: smartProps.string.withDefault(""),
    media5Link: smartProps.string.withDefault(""),
  },
  setup: {
    title: "Home Medias",
  },
});
